export const PLATFORMS = {
	cc: 'cc',
	ps: 'ps',
	hatch: 'hatch',
	hatchStage: 'hatch-stage'
};
